const TimeCal = (created_at) => {
  let ms;
  if (typeof created_at === 'number' && created_at < 1e12) {
    ms = created_at * 1000;  // seconds → milliseconds
  } else {
    ms = new Date(created_at).getTime();
  }
  const diffSec = Math.floor((Date.now() - ms) / 1000);
  const diffMin = Math.floor(diffSec / 60);
  const diffHour = Math.floor(diffMin / 60);
  const diffDay = Math.floor(diffHour / 24);

  if (diffSec < 60) return 'Registered just now';
  if (diffMin < 60) return `Registered ${diffMin} minute${diffMin === 1 ? '' : 's'} ago`;
  if (diffHour < 24) return `Registered ${diffHour} hour${diffHour === 1 ? '' : 's'} ago`;
  if (diffDay < 30) return `Registered ${diffDay} day${diffDay === 1 ? '' : 's'} ago`;
  // Approximate months (30 days) and years (365 days)
  const diffMonth = Math.floor(diffDay / 30);
  if (diffMonth < 12) return `Registered ${diffMonth} month${diffMonth === 1 ? '' : 's'} ago`;
  const diffYear = Math.floor(diffDay / 365);
  return `Registered ${diffYear} year${diffYear === 1 ? '' : 's'} ago`;
};

export default TimeCal;